module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "form-room-container"
  }, [_c('v-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveForm($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md8": "",
      "body-border-right": ""
    }
  }, [_c('div', {
    staticClass: "body-border-bottom mb-3"
  }, [_c('v-layout', {
    staticClass: "form-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "label-section"
  }, [_c('p', [_vm._v("Detalles de la habitacion")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.subsidiaries,
      "label": "Sucursal",
      "item-text": "name",
      "item-value": "id",
      "single-line": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.loadBuildings
    },
    model: {
      value: (_vm.model.com_subsidiaries_id),
      callback: function($$v) {
        _vm.model.com_subsidiaries_id = $$v
      },
      expression: "model.com_subsidiaries_id"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.buildings,
      "disabled": _vm.buildings.length === 0,
      "label": "Edificio",
      "item-text": "name",
      "item-value": "id",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.model.building_id),
      callback: function($$v) {
        _vm.model.building_id = $$v
      },
      expression: "model.building_id"
    }
  })], 1)])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "form-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "label-section"
  }, [_c('label', [_vm._v("Tipo de habitacion")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "label-section"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nombre de habitacion")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "label-section"
  }, [_c('label', {
    attrs: {
      "for": "quantity"
    }
  }, [_vm._v("Cantidad")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.categories,
      "label": "Habitacion",
      "single-line": "",
      "bottom": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.model.flagroom),
      callback: function($$v) {
        _vm.model.flagroom = $$v
      },
      expression: "model.flagroom"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.name),
      expression: "model.name"
    }],
    staticClass: "input-form",
    attrs: {
      "id": "name",
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.quantity),
      expression: "model.quantity"
    }],
    staticClass: "input-form",
    attrs: {
      "id": "quantity",
      "name": "quantity",
      "type": "text"
    },
    domProps: {
      "value": (_vm.model.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.quantity = $event.target.value
      }
    }
  })])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "form-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "label-section"
  }, [_c('label', {
    attrs: {
      "for": "color"
    }
  }, [_vm._v("Color Picker")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md8": ""
    }
  }, [_c('div', {
    staticClass: "label-section"
  }, [_c('label', {
    attrs: {
      "for": "code"
    }
  }, [_vm._v("Codigo de la habitacion")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "color-picker"
  }, [_c('v-menu', {
    attrs: {
      "offset-x": "",
      "close-on-content-click": false,
      "top": true,
      "full-width": true
    },
    model: {
      value: (_vm.showColorPicker),
      callback: function($$v) {
        _vm.showColorPicker = $$v
      },
      expression: "showColorPicker"
    }
  }, [_c('div', {
    slot: "activator"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.color),
      expression: "model.color"
    }],
    staticClass: "input-form",
    attrs: {
      "id": "color",
      "name": "color",
      "type": "text"
    },
    domProps: {
      "value": (_vm.model.color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.color = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "current-color",
    style: (_vm.currentPicker)
  })]), _vm._v(" "), _c('v-list', {
    staticClass: "menu-color-picker"
  }, [_c('button', {
    staticClass: "btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showColorPicker = false
      }
    }
  }, [_vm._v("Cerrar")]), _vm._v(" "), _c('chrome-picker', {
    attrs: {
      "value": _vm.colors
    },
    on: {
      "input": _vm.onUpdateColor
    }
  })], 1)], 1)], 1)])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "control text-xs-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.code_roomtype),
      expression: "model.code_roomtype"
    }],
    staticClass: "input-form",
    attrs: {
      "id": "code",
      "name": "code",
      "type": "text",
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.model.code_roomtype)
    },
    on: {
      "keyup": function($event) {
        _vm.textToUpperCase(_vm.model.code_roomtype)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.code_roomtype = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "helper"
  }, [_vm._v("Máximo 3 caracteres")])])])], 1)], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "label-section"
  }, [_c('label', {
    attrs: {
      "for": "manual"
    }
  }, [_vm._v("Manual de la habitacion")])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-3",
    attrs: {
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "control full"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.manual_title),
      expression: "model.manual_title"
    }],
    staticClass: "input-form",
    attrs: {
      "id": "manual",
      "name": "manual",
      "type": "text"
    },
    domProps: {
      "value": (_vm.model.manual_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.manual_title = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('file-upload-container', {
    staticClass: "mb-3",
    attrs: {
      "label-for": "manual-url",
      "allowed-files": ['PDF'],
      "image-url": _vm.model.manual_url,
      "disable-validation": true,
      "preview-image": false
    },
    on: {
      "upload": _vm.onUploadImage
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md2": ""
    }
  }, [_c('v-btn', {
    staticClass: "save-btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tGuardar\n\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee1572e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/housekeeping/rooms/FormRoom.vue
// module id = 1699
// module chunks = 10